// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PlEnCmtAEWOBOC3_gIuh {
  position: absolute;
  top: 2.2rem;
  left: 50%;
  transform: translateX(-50%);
  background-color: var(--bar-background);
  color: var(--bar-color);
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 6px;
  cursor: pointer;
  z-index: 1;
  font-size: 1.2rem;
  transition: all 0.6s;
}
.PlEnCmtAEWOBOC3_gIuh.on {
  color: var(--highlight);
}
.FK2E7xoj0UqwBVtCVNTH {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: var(--bar-background);
  color: var(--border-color);
  border: 1px solid var(--dry-resizer-color);
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  gap: 0.2em;
  cursor: auto;
  user-select: none;
  z-index: 1;
}
.FK2E7xoj0UqwBVtCVNTH > .icon {
  font-size: 1.15rem;
  color: var(--bar-color);
  padding: 0.2em 0.1em;
  border-radius: 6px;
  cursor: pointer;
}
.FK2E7xoj0UqwBVtCVNTH > .icon:hover {
  background-color: var(--hover-background);
}
.FK2E7xoj0UqwBVtCVNTH > .icon:disabled {
  opacity: 0.6;
  cursor: auto;
}
.FK2E7xoj0UqwBVtCVNTH > .icon:disabled:hover {
  background-color: inherit;
  color: revert;
}
.FK2E7xoj0UqwBVtCVNTH > .icon:nth-child(1),
.FK2E7xoj0UqwBVtCVNTH > .icon:nth-child(2) {
  transform: rotate(90deg);
}
.FK2E7xoj0UqwBVtCVNTH > .icon:nth-child(2) {
  margin-bottom: 0.6em;
}
.FK2E7xoj0UqwBVtCVNTH > .icon:nth-child(3),
.FK2E7xoj0UqwBVtCVNTH > .icon:nth-child(4) {
  transform: rotate(-90deg);
}
.resizer {
  user-select: none;
}
.left > div .path {
  padding-right: 1rem;
}
.right > div .path {
  padding-left: 1rem;
}
.sync .breadcrumbs {
  border-color: var(--highlight);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"synctoggle": `PlEnCmtAEWOBOC3_gIuh`,
	"on": `on`,
	"transfertoolbar": `FK2E7xoj0UqwBVtCVNTH`,
	"icon": `icon`,
	"resizer": `resizer`,
	"left": `left`,
	"path": `path`,
	"right": `right`,
	"sync": `sync`,
	"breadcrumbs": `breadcrumbs`
};
export default ___CSS_LOADER_EXPORT___;
